import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Hero from "../components/hero"
import { ReportDownloadItem } from "../components/report"

const reportItem = {
  href: "/documents/lid-2026-report.pdf",
  title: "Law in Distress 2026 Report",
  thumbnailSrc: "/images/lid-report-thumbnail.jpg",
  thumbnailAlt: "Law in Distress 2026 Report cover",
  buttonLabel: "Download Report",
  downloadFilename: "LID-Report-2026.pdf",
  eventName: "download 2026 report",
}

const surveyItem = {
  href: "/documents/lid-lawyers-survey-july-2026.pdf",
  title: "Copy of Law in Distress Survey",
  thumbnailSrc: "/images/lid-survey-thumbnail.jpg",
  thumbnailAlt: "Copy of Law in Distress Survey cover",
  buttonLabel: "Download Survey",
  downloadFilename: "LID-SurveyCopy-2022.pdf",
  eventName: "download 2026 survey",
}

const Report2026 = ({ data }) => {
  const heroContent = data.markdownRemark.frontmatter.hero

  return (
    <Layout classes="team">
      <Seo title={heroContent.title} />
      <Hero heroContent={heroContent} />
      <section className="report-content report-content--stacked">
        <div className="container">
          <ReportDownloadItem {...reportItem} />
          <ReportDownloadItem {...surveyItem} />
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    markdownRemark(frontmatter: { template_key: { eq: "2026-report" } }) {
      frontmatter {
        title
        hero {
          small_title
          title
        }
      }
    }
  }
`

export default Report2026
